export default "__VITE_ASSET__DZizfQga__"